import React from 'react';

export const ContactSection: React.FC = () => {
  return (
    <section id="contact" className="py-20 bg-orange-50">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Contact Info */}
          <div>
            <h2 className="text-4xl font-bold text-gray-800 mb-6">
              Get Your Free Quote Today!
            </h2>
            <p className="text-xl text-gray-600 mb-8 leading-relaxed">
              Ready to protect your home with GutterBrush Simple Gutter Guards?
              Get a free quote via satellite measurement or schedule a no-obligation call
              with our friendly experts Randy or Alex.
            </p>

            <div className="space-y-6">
              <div className="flex items-start">
                <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-satellite-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-800 mb-2">Free Satellite Measurement</h3>
                  <p className="text-gray-600">Get accurate pricing without anyone visiting your home. Advanced satellite technology provides precise measurements.</p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-phone-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-800 mb-2">Expert Consultation</h3>
                  <p className="text-gray-600">Talk with Randy or Alex, our friendly local gutter and home improvement experts. Get personalized recommendations.</p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-money-dollar-circle-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-800 mb-2">Affordable Protection</h3>
                  <p className="text-gray-600">Most homes can be completely protected for just $300-$400. Made in USA since 2004.</p>
                </div>
              </div>
            </div>

            <div className="mt-8 p-6 bg-white rounded-lg">
              <h4 className="font-bold text-gray-800 mb-4">Why Choose GutterBrush?</h4>
              <ul className="space-y-2">
                <li className="flex items-center text-gray-700">
                  <i className="ri-check-line text-green-500 mr-2"></i>
                  Made in USA since 2004
                </li>
                <li className="flex items-center text-gray-700">
                  <i className="ri-check-line text-green-500 mr-2"></i>
                  6 diameters available (2.25&quot; to 8.0&quot;)
                </li>
                <li className="flex items-center text-gray-700">
                  <i className="ri-check-line text-green-500 mr-2"></i>
                  Easy DIY installation
                </li>
                <li className="flex items-center text-gray-700">
                  <i className="ri-check-line text-green-500 mr-2"></i>
                  Minimal maintenance required
                </li>
              </ul>
            </div>
          </div>

          {/* Klaviyo Form */}
          <div className="bg-white rounded-lg p-8">
            <h3 className="text-2xl font-bold text-gray-800 mb-6">Request Your Free Quote</h3>
            <div className="klaviyo-form-QNumqx"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
